
/* This file is autogenerated by "pnpm run generateIconComponents" command */
export enum IconNameTypes {
    AddressBook = 'AddressBook',
    Airport = 'Airport',
    America = 'America',
    Anchor = 'Anchor',
    Archive = 'Archive',
    ArrowDiagonalUp = 'ArrowDiagonalUp',
    ArrowDown = 'ArrowDown',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    ArrowUp = 'ArrowUp',
    ArrowsOrder = 'ArrowsOrder',
    Asia = 'Asia',
    AtSign = 'AtSign',
    Attach = 'Attach',
    AudioFile = 'AudioFile',
    BalanceScaleRight = 'BalanceScaleRight',
    BarChart = 'BarChart',
    Battery = 'Battery',
    Bicycle = 'Bicycle',
    BirthdayCake = 'BirthdayCake',
    Book = 'Book',
    Bookmark = 'Bookmark',
    Bot = 'Bot',
    BoxImportant = 'BoxImportant',
    BritishPound = 'BritishPound',
    Burger = 'Burger',
    Bus = 'Bus',
    Calculator = 'Calculator',
    Calendar = 'Calendar',
    Camera = 'Camera',
    Camper = 'Camper',
    Car = 'Car',
    CarCheck = 'CarCheck',
    Caravan = 'Caravan',
    Carpool = 'Carpool',
    Carside = 'Carside',
    Certificate = 'Certificate',
    ChargingStation = 'ChargingStation',
    Check = 'Check',
    CheckColourGreen = 'CheckColourGreen',
    CheckedUserMale = 'CheckedUserMale',
    ChevronDown = 'ChevronDown',
    ChevronLeft = 'ChevronLeft',
    ChevronRight = 'ChevronRight',
    ChevronUp = 'ChevronUp',
    City = 'City',
    Clock = 'Clock',
    Close = 'Close',
    CloseThin = 'CloseThin',
    Coffee = 'Coffee',
    Coins = 'Coins',
    Comments = 'Comments',
    CommentsColour = 'CommentsColour',
    Commercial = 'Commercial',
    Communication = 'Communication',
    Compass = 'Compass',
    ContactDetails = 'ContactDetails',
    Copy = 'Copy',
    CrashedCar = 'CrashedCar',
    CreditCard = 'CreditCard',
    Crosslink = 'Crosslink',
    Customer = 'Customer',
    DBLogoRed = 'DBLogoRed',
    Document = 'Document',
    DocumentColour = 'DocumentColour',
    DocumentSearch = 'DocumentSearch',
    DocumentSearchColour = 'DocumentSearchColour',
    Download = 'Download',
    DownloadFromCloud = 'DownloadFromCloud',
    DownloadV2 = 'DownloadV2',
    ECar = 'ECar',
    Edit = 'Edit',
    Electrical = 'Electrical',
    Environment = 'Environment',
    Error = 'Error',
    Euro = 'Euro',
    Europe = 'Europe',
    Evergreen = 'Evergreen',
    Eye = 'Eye',
    Facebook = 'Facebook',
    Factory = 'Factory',
    File = 'File',
    FileInvoice = 'FileInvoice',
    Filter = 'Filter',
    Fingerprint = 'Fingerprint',
    Flag = 'Flag',
    FlagsBg = 'FlagsBg',
    FlagsBr = 'FlagsBr',
    FlagsCn = 'FlagsCn',
    FlagsCz = 'FlagsCz',
    FlagsDe = 'FlagsDe',
    FlagsDk = 'FlagsDk',
    FlagsEe = 'FlagsEe',
    FlagsEn = 'FlagsEn',
    FlagsEs = 'FlagsEs',
    FlagsFi = 'FlagsFi',
    FlagsFr = 'FlagsFr',
    FlagsGb = 'FlagsGb',
    FlagsGr = 'FlagsGr',
    FlagsHk = 'FlagsHk',
    FlagsHr = 'FlagsHr',
    FlagsIt = 'FlagsIt',
    FlagsKr = 'FlagsKr',
    FlagsLv = 'FlagsLv',
    FlagsNl = 'FlagsNl',
    FlagsNo = 'FlagsNo',
    FlagsPl = 'FlagsPl',
    FlagsPt = 'FlagsPt',
    FlagsRo = 'FlagsRo',
    FlagsRu = 'FlagsRu',
    FlagsSe = 'FlagsSe',
    FlagsSk = 'FlagsSk',
    FlagsTr = 'FlagsTr',
    FlagsTw = 'FlagsTw',
    FlagsVn = 'FlagsVn',
    FlagsZh = 'FlagsZh',
    Folder = 'Folder',
    GetQuote = 'GetQuote',
    Gift = 'Gift',
    Globe = 'Globe',
    GlobeAfrica = 'GlobeAfrica',
    GlobeCounter = 'GlobeCounter',
    GlobeStylized = 'GlobeStylized',
    GpsSignal = 'GpsSignal',
    GraduationCap = 'GraduationCap',
    Grin = 'Grin',
    Hand = 'Hand',
    HandHoldingDollar = 'HandHoldingDollar',
    HandHoldingHeart = 'HandHoldingHeart',
    HandPointRight = 'HandPointRight',
    HandUp = 'HandUp',
    Handshake = 'Handshake',
    Hauptuntersuchung = 'Hauptuntersuchung',
    Headphones = 'Headphones',
    Heart = 'Heart',
    HelpingHand = 'HelpingHand',
    Hierarchy = 'Hierarchy',
    Home = 'Home',
    Hospital = 'Hospital',
    Hourglass = 'Hourglass',
    Hu = 'Hu',
    IceCreamCone = 'IceCreamCone',
    Identification = 'Identification',
    ImageFile = 'ImageFile',
    InfinityIcon = 'InfinityIcon',
    Info = 'Info',
    Instagram = 'Instagram',
    Ipad = 'Ipad',
    Key = 'Key',
    LanguageDe = 'LanguageDe',
    LanguageEn = 'LanguageEn',
    LanguageNo = 'LanguageNo',
    LaughBeam = 'LaughBeam',
    LaughWink = 'LaughWink',
    Leaf = 'Leaf',
    Light = 'Light',
    Link = 'Link',
    Linkedin = 'Linkedin',
    List = 'List',
    Location = 'Location',
    LocationPinSingle = 'LocationPinSingle',
    Locations = 'Locations',
    Lock = 'Lock',
    MailBulk = 'MailBulk',
    Maintenance = 'Maintenance',
    Map = 'Map',
    Microscope = 'Microscope',
    Minus = 'Minus',
    ModulesDownloadsAudioFile = 'ModulesDownloadsAudioFile',
    ModulesDownloadsFile = 'ModulesDownloadsFile',
    ModulesDownloadsImageFile = 'ModulesDownloadsImageFile',
    ModulesDownloadsVideoFile = 'ModulesDownloadsVideoFile',
    MoneyBill = 'MoneyBill',
    MoneyBillWave = 'MoneyBillWave',
    MoneyBox = 'MoneyBox',
    More = 'More',
    Motorcycle = 'Motorcycle',
    MpuInformationEvent = 'MpuInformationEvent',
    Museum = 'Museum',
    Neuter = 'Neuter',
    News = 'News',
    Note = 'Note',
    Notification = 'Notification',
    OpenBook = 'OpenBook',
    OpenDoor = 'OpenDoor',
    Organization = 'Organization',
    Padlock = 'Padlock',
    Pause = 'Pause',
    Pdf = 'Pdf',
    Phone = 'Phone',
    PhoneColour = 'PhoneColour',
    Pin = 'Pin',
    Play = 'Play',
    Plus = 'Plus',
    Print = 'Print',
    QrCode = 'QrCode',
    ReadMessage = 'ReadMessage',
    Reading = 'Reading',
    Refresh = 'Refresh',
    Reset = 'Reset',
    Rocket = 'Rocket',
    Save = 'Save',
    Search = 'Search',
    SecuredLetter = 'SecuredLetter',
    Settings = 'Settings',
    ShockAbsorber = 'ShockAbsorber',
    ShoppingCart = 'ShoppingCart',
    Shutdown = 'Shutdown',
    Speedometer = 'Speedometer',
    Stack = 'Stack',
    Star = 'Star',
    Stopwatch = 'Stopwatch',
    StudentMale = 'StudentMale',
    SuitcaseRolling = 'SuitcaseRolling',
    Sun = 'Sun',
    Tags = 'Tags',
    TargetWorld = 'TargetWorld',
    Tasklist = 'Tasklist',
    Teacher = 'Teacher',
    ThumbsUp = 'ThumbsUp',
    Tiktok = 'Tiktok',
    Today = 'Today',
    Toolbox = 'Toolbox',
    TrailerBraked = 'TrailerBraked',
    TrailerUnbraked = 'TrailerUnbraked',
    Translation = 'Translation',
    Truck = 'Truck',
    Tv = 'Tv',
    TvV1 = 'TvV1',
    TwoHands = 'TwoHands',
    Ung = 'Ung',
    Upload = 'Upload',
    UsDollar = 'UsDollar',
    User = 'User',
    UserAccount = 'UserAccount',
    UserGroups = 'UserGroups',
    UserSecured = 'UserSecured',
    UserWithYellowBorder = 'UserWithYellowBorder',
    Vector = 'Vector',
    VideoCall = 'VideoCall',
    VideoFile = 'VideoFile',
    Wait = 'Wait',
    Waste = 'Waste',
    Water = 'Water',
    WaterTransportation = 'WaterTransportation',
    WiFi = 'WiFi',
    Woman = 'Woman',
    Worker = 'Worker',
    Xing = 'Xing',
    Youtube = 'Youtube',
}
